import React from "react";
import { skillGroups } from "../../v3/data";

const Skills = () => (
  <section id="skills" className="section rv">
    <div className="pagewrap">
      <div className="shead">
        <div>
          <div className="snum">[ 03 / SKILLS ]</div>
          <h2 className="h2">The spec sheet.</h2>
        </div>
        <span className="mono hide-mobile" style={{ fontSize: 12, color: "var(--muted)" }}>
          60+ TOOLS · 7 DOMAINS
        </span>
      </div>
      <div style={{ borderBottom: "1px solid var(--line)" }}>
        {skillGroups.map((g) => (
          <div key={g.label} className="skill-row stag">
            <div>
              <div className="disp fw6" style={{ fontSize: 16 }}>
                {g.label}
              </div>
              <div className="mono" style={{ fontSize: 11, color: "#94A3B8", marginTop: 4 }}>
                {g.count}
              </div>
            </div>
            <div className="fx wrap gap8">
              {g.items.map((it) => (
                <span key={it} className="tag">
                  {it}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
